module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/hairstyle_03@2x-19683026f8b5048549149851c2d6b3f4.webp";